var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 6.6693V23.018C30.25 24.3518 29.1637 25.5755 27.83 25.7405L27.4038 25.7955C25.1488 26.098 21.9725 27.033 19.415 28.1055C18.5212 28.4768 17.5312 27.803 17.5312 26.8268V7.70055C17.5312 7.1918 17.82 6.7243 18.2737 6.4768C20.79 5.11555 24.5988 3.90555 27.1838 3.68555H27.2662C28.9163 3.68555 30.25 5.0193 30.25 6.6693Z",
    fill: "#EBAB11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7244 6.4768C12.2081 5.11555 8.39937 3.90555 5.81437 3.68555H5.71812C4.06812 3.68555 2.73438 5.0193 2.73438 6.6693V23.018C2.73438 24.3518 3.82062 25.5755 5.15438 25.7405L5.58062 25.7955C7.83562 26.098 11.0119 27.033 13.5694 28.1055C14.4631 28.4768 15.4531 27.803 15.4531 26.8268V7.70055C15.4531 7.17805 15.1781 6.7243 14.7244 6.4768ZM6.87313 10.643H9.96688C10.5306 10.643 10.9981 11.1105 10.9981 11.6743C10.9981 12.2518 10.5306 12.7055 9.96688 12.7055H6.87313C6.30938 12.7055 5.84188 12.2518 5.84188 11.6743C5.84188 11.1105 6.30938 10.643 6.87313 10.643ZM10.9981 16.8305H6.87313C6.30938 16.8305 5.84188 16.3768 5.84188 15.7993C5.84188 15.2355 6.30938 14.768 6.87313 14.768H10.9981C11.5619 14.768 12.0294 15.2355 12.0294 15.7993C12.0294 16.3768 11.5619 16.8305 10.9981 16.8305Z",
    fill: "#EBAB11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/values.afa5387f7d7beacf377781328588f53f.svg";
export { ForwardRef as ReactComponent };